import React from "react";
import SafeCallComponent from "../LabOrderItem/children/SafeCallComponent";
const LabOrderPendingActions = () => {
  return (
    <>
      <div className="flex-column waiting-for-price-buttons">
        <SafeCallComponent />
      </div>
    </>
  );
};

export default LabOrderPendingActions;